import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import EnfantCoursList from "./enfantCours/EnfantCoursList";
import {directusContext} from "../../app/DirectusProvider";
import moment from "moment";
import Title from "../common/Title";
import Presence from "../../app/config/Presence";
import Modal from "../common/Modal";
import LoadingSpinner from "../common/LoadingSpinner";
import {useTranslation} from "react-i18next";

const COURS_FIELDS = ["id", "date", "groupe.nom", "enfants.presence", "enfants.enfant_id"];
const ADD_ACTIVATED = true;

const CoursEdit = () => {

    const {directus, updateVersion, version} = useContext(directusContext);
    const {t} = useTranslation();
    const {id} = useParams();
    const [cours, setCours] = useState(null);
    const [isAddModalOpened, setIsAddModalOpened] = useState(false);
    const [enfants, setEnfants] = useState(null);
    const [enfantSearch, setEnfantSearch] = useState("");


    useEffect(() => {
        directus.items("cours").readOne(id, {fields: COURS_FIELDS}).then((data) => {
            setCours(data);
        });
    }, [directus, id]);

    const openAddModal = () => {
        directus.items("enfant").readByQuery({
            limit: -1,
            sort: "prenom",
            filter: {
                "_and": [
                    {
                        "id": {
                            "_nin": cours["enfants"].length > 0 ? cours["enfants"].map(i => i["enfant_id"]) : null
                        }
                    }
                ]
            }
        }).then(({data}) => {
            setEnfants(data);
        });
        setIsAddModalOpened(true);
    }

    const closeAddModal = () => {
        setIsAddModalOpened(false);
        setEnfants(null);
    }

    const addEnfant = (enfantId) => {
        directus.items("cours").updateOne(id, {
            "enfants": [
                ...cours["enfants"],
                {
                    "enfant_id": enfantId
                }
            ]
        }, {fields: COURS_FIELDS}).then(data => {
            setCours(data);
            updateVersion();
            closeAddModal();
        })


    }

    const nbEnfantsPresent = cours?.enfants?.filter((e) => e.presence === Presence.present.value).length;
    return (
        <>
            <Title
                title={`${cours?.date ? moment(cours.date, "YYYY-MM-DD").format("DD.MM.YYYY") : t("toast.enCours")}${cours?.groupe?.nom ? ` – ${cours.groupe?.nom}` : ""}`}
                subtitle={nbEnfantsPresent ? `${nbEnfantsPresent} enfants` : ""}/>
            {isAddModalOpened && <Modal modalTitle={t("coursEdit.ajoutEnfant.titre")} onClose={closeAddModal}>

                {!enfants && <div className={"absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"}>
                    <LoadingSpinner color={"black"} size={10}
                                    className={"absolute top-1/2 left-1/2 transform -translate-x-1/2  -translate-y-1/2"}/>
                </div>}


                <label htmlFor="enfantSearch" className="sr-only">{t("coursEdit.ajoutEnfant.rechercher")}</label>
                <div className="relative w-full">
                    <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                             viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd"
                                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                  clipRule="evenodd"></path>
                        </svg>
                    </div>
                    <input type="text" id="enfantSearch"
                           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                           placeholder={t("coursEdit.ajoutEnfant.rechercher")} required onChange={(e) => {
                        setEnfantSearch(e.target.value)
                    }
                    }/>
                </div>

                {enfants && <div className={"overflow-scroll"}>
                    {enfants.map((e) => {

                        const re = new RegExp(enfantSearch, 'gim');
                        //S'il y a une recherche et que le nom et le prénom ne match pas, on n'affiche pas l'element
                        if (enfantSearch.length > 0 && !((e['nom'] && e['nom'].match(re)) || (e['prenom'] && e['prenom'].match(re)))) return null;

                        return (
                            <button type={"button"} key={`addList-enfant-${e['id']}`}
                                    className={"shadow bg-gray-100 px-2 py-3 my-2 rounded w-full"}
                                    onClick={() => {
                                        addEnfant(e['id'])
                                    }}>
                                {e['prenom']} {e['nom']}
                            </button>
                        )
                    })}
                </div>}
            </Modal>}

            {!window.localStorage.getItem("coursEditHelp") && <div className={"p-2 flex flex-row justify-between"}>
                <div className={"p-2"}>{t("presence.label")}:</div>
                {[Presence.absent, Presence.excuse, Presence.present].map((p) => {
                    return (
                        <div className={"inline p-2 rounded-full"} style={{background: p.color}}
                             key={`presence-${p.value}`}><span
                            className={"font-bold"}>{t(p.text)[0]}</span>{t(p.text).substring(1,)}</div>
                    )
                })}
            </div>}

            <EnfantCoursList coursId={cours?.id} key={`EnfantCoursList-${version}`}/>
            {ADD_ACTIVATED && !isAddModalOpened &&
                <button type={"button"}
                        className={"fixed shadow-2xl rounded-full font-bold text-4xl bg-gray-50 border-4 border-gray-200"}
                        style={{
                            bottom: "10vh",
                            right: "3vw",
                            height: "50px",
                            width: "50px"
                        }} onClick={openAddModal}>+
                </button>}
        </>
    );
};

export default CoursEdit;
